"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_service_1 = require("../shared/resource.service");
var http_1 = require("@angular/common/http");
var shift_report_serializer_1 = require("./shift-report.serializer");
var ShiftDashboardService = /** @class */ (function (_super) {
    __extends(ShiftDashboardService, _super);
    function ShiftDashboardService(http) {
        return _super.call(this, http, 'shifts/dashboard/', new shift_report_serializer_1.ShiftReportSerializer()) || this;
    }
    return ShiftDashboardService;
}(resource_service_1.ResourceService));
exports.ShiftDashboardService = ShiftDashboardService;
